(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Mobile nav
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  // Scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window) || reduce) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var d = entry.target.getAttribute('data-delay') || 0;
          setTimeout(function () { entry.target.classList.add('is-visible'); }, Number(d));
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  if (reduce) return;

  // Hero parallax
  var hero = document.querySelector('[data-parallax]');
  if (hero) {
    var raf = 0;
    var onScroll = function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var y = window.scrollY;
        hero.style.setProperty('--par-img', (y * 0.25) + 'px');
        hero.style.setProperty('--par-txt', (y * -0.08) + 'px');
        hero.style.setProperty('--par-rot', Math.min(y * 0.012, 6) + 'deg');
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // 3D tilt on cards
  document.querySelectorAll('[data-tilt]').forEach(function (el) {
    var frame = 0;
    el.addEventListener('mousemove', function (e) {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        el.style.setProperty('--ry', ((px - 0.5) * 14).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - py) * 14).toFixed(2) + 'deg');
        el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        el.style.setProperty('--glare', '0.5');
      });
    });
    el.addEventListener('mouseleave', function () {
      cancelAnimationFrame(frame);
      el.style.setProperty('--rx', '0deg');
      el.style.setProperty('--ry', '0deg');
      el.style.setProperty('--glare', '0');
    });
  });
})();
